export default {
  list: [],
  listLoading: false,
  listMeta: {},
};
